export default "__VITE_ASSET__DKrLmrRm__"